import { apiFetch } from "@/lib/apiClient";

export type SettingFieldType = "text" | "number" | "select" | "textarea" | "recipients";

export interface SettingFieldDef {
  key: string;
  label: string;
  type: SettingFieldType;
  placeholder: string | null;
  help: string | null;
  sensitive: boolean;
  options: string[] | null;
  wide: boolean;
  rows: number | null;
}

export interface SettingSectionDef {
  title: string;
  description: string;
  fields: SettingFieldDef[];
}

export interface SettingPageDef {
  slug: string;
  label: string;
  summary: string;
  sections: SettingSectionDef[];
}

export interface SettingValue {
  value: string | null;
  isSet: boolean;
  isSensitive: boolean;
}

export interface SettingsResponse {
  pages: SettingPageDef[];
  values: Record<string, SettingValue>;
}

export const SETTINGS_MASK = "••••••••";

export const settings = {
  async get(): Promise<SettingsResponse> {
    const res = await apiFetch<SettingsResponse>("/settings");
    return {
      pages: res?.pages ?? [],
      values: res?.values ?? {},
    };
  },

  save(updates: Record<string, string | null>) {
    return apiFetch<{ updated: number }>("/settings", {
      method: "POST",
      body: JSON.stringify(updates),
    });
  },

  testEmail(to: string) {
    return apiFetch<{ sent: boolean }>("/settings/test-email", {
      method: "POST",
      body: JSON.stringify({ to }),
    });
  },

  testVerificationEmail(to?: string) {
    return apiFetch<{ sent: boolean }>(
      "/settings/test-verification-email",
      { method: "POST", body: JSON.stringify({ to: to ?? null }) },
    );
  },

  testSms(to: string) {
    return apiFetch<{ sent: boolean }>("/settings/test-sms", {
      method: "POST",
      body: JSON.stringify({ to }),
    });
  },
};
